import Icon from '../components/Icon.vue'

Icon.register({"share-alt":{"width":1536,"height":1792,"paths":[{"d":"M1216 1024q133 0 226.5 93.5t93.5 226.5-93.5 226.5-226.5 93.5-226.5-93.5-93.5-226.5q0-12 2-34l-360-180q-92 86-218 86-133 0-226.5-93.5t-93.5-226.5 93.5-226.5 226.5-93.5q126 0 218 86l360-180q-2-22-2-34 0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5-93.5 226.5-226.5 93.5q-126 0-218-86l-360 180q2 22 2 34t-2 34l360 180q92-86 218-86z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/share-alt.js
// module id = 862
// module chunks = 0